export default __webpack_public_path__ + "static/media/scratch-card.9b79d35c.svg";